import Comments from '@/components/Comments';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';
import { SafeAreaView } from 'react-native-safe-area-context';

const CommentsSection = () => {
  const { route, id, type } = useLocalSearchParams();
  const sid = Array.isArray(id) ? id[0] : id;
  const stype = Array.isArray(type) ? type[0] : type;

  return (
    <SafeAreaView className="h-full w-full">
      {sid && stype && <Comments id={sid} type={stype} />}
    </SafeAreaView>
  );
};

export default CommentsSection;
